function p({
  codeName: e = "GAR_COMPONENT_CODENAME",
  componentId: t = 1,
  displayName: n = "COMPONENT",
  name: o = "GAR - Component",
  type: r = "App",
  settings: i
}) {
  return {
    children: [],
    codeName: e,
    componentId: t,
    customEvents: [],
    displayName: n,
    height: null,
    mountEvent: {
      eventName: "mount_event",
      function: "GAR.init",
      settings: {
        componentId: t,
        length: 0
      },
      type: "Mount"
    },
    name: o,
    order: 4,
    parentComponentCodeName: "parent_component_code_name",
    parentComponentId: 5357,
    parentComponentName: "Parent Component Name",
    settings: i,
    state: {},
    type: r,
    unmountEvent: null,
    width: null
  };
}
function m(e = {}) {
  return {
    codeName: "GAR_COMPONENT_CODENAME",
    componentId: 1,
    displayName: "COMPONENT",
    name: "GAR - Component",
    type: "App",
    settings: {
      componentId: 1,
      widget_code_name: "gar_widget_code_name"
    },
    ...e
  };
}
const b = {
  gaPageTitle: "Gallup Access",
  common: {
    addAntiForgeryToken: () => "__RequestVerificationToken=token",
    getAttributeValue: (e = "1") => e
  },
  pc: {
    getByCodeName: (e) => p(m({ codeName: e })),
    getById: (e) => p(m({ componentId: e }))
  },
  widget: { attributeNames: { clientId: "1" } }
}, _ = {
  getDashboardWidgetId: () => "dashboard-widget-id",
  getFullAppUrl: (e, t) => "https://garqa.gallup.com",
  getSiteLanguage: () => "en-US",
  getWidgetSettings: (e, t) => Promise.resolve({ settings: { "widget-settings": "widget-settings" } }),
  progressHide: () => {
  },
  progressShow: () => {
  },
  setRequiredData: (e, t) => {
  },
  setWidgetContainerContent: (e, t) => document.createElement("div"),
  setWidgetStatus: (e, t) => {
  }
};
function y(e) {
  window.GSS = { ...b, ...e == null ? void 0 : e.gss }, window.PortalContainer = { ..._, ...e == null ? void 0 : e.portalContainer };
}
function T(e) {
  a() || y(e);
}
function a() {
  return typeof window < "u" ? window.GSS !== void 0 : !1;
}
function C(e, t) {
  if (!t || t.size === 0)
    return e;
  let n = e.includes("?") ? e.substring(0, e.indexOf("?")) : e;
  const o = e.substring(e.indexOf("?") + 1);
  o && o.split("&").forEach((i) => {
    if (i.includes("=")) {
      const s = i.split("=");
      t.set(s[0], s[1]);
    }
  });
  let r = 0;
  return t.forEach((i, s) => {
    r === 0 ? n = n + "?" : n = n + "&", n = `${n}${s}=${i}`, r++;
  }), n;
}
function R(e, t) {
  return t && (e.indexOf("?") === -1 ? e = e + "?" + t : e = e + "&" + t), e;
}
function D(e = "app", t, n = !0) {
  let o;
  if (e === "app")
    o = I();
  else if ((e === "page" || e === "section") && t) {
    const i = S(t, n);
    o = E(i);
  }
  o || (console.warn("Unable to get the GSS component container. Appending container to the body."), o = document.body);
  let r = document.createElement("div");
  return t && (r.id = t), o.appendChild(r), r;
}
function N(e, t, n = !0) {
  if (!e) {
    console.error("Invalid component URI");
    return;
  }
  let o = /* @__PURE__ */ new Map();
  if (a()) {
    let r;
    if (t) {
      const s = S(t, n);
      r = window.GSS.pc.Components.getByCodeName(s);
    }
    if (!r) {
      console.warn(
        "Unable to get component settings using the widget code name: " + t + ". Trying dump instead."
      );
      const s = Object.values(
        window.GSS.pc.Components.dump()
      );
      if (s) {
        const d = Array.isArray(s) ? [["", s[0]]] : Object.entries(s);
        if (d.length === 1)
          r = d[0][1];
        else
          for (const f of d) {
            const u = f[1], c = u == null ? void 0 : u.settings, l = (c == null ? void 0 : c.widgetCodeName) || (c == null ? void 0 : c.widget_code_name);
            (l == null ? void 0 : l.toLowerCase()) === t.toLowerCase() && (r = f[1]);
          }
      }
    }
    if (!r) {
      console.warn("Unable to get component settings using the widget code name: " + t + ".");
      return;
    }
    const i = h(r.componentId);
    i && (o.set("gssClientId", i.gssClientId), o.set("gssComponentId", i.gssComponentId), o.set("componentDefinitionCodeName", i.componentDefinitionCodeName), o.set("__RequestVerificationToken", i.__RequestVerificationToken));
  }
  return C(e, o);
}
function W(e) {
  let t = document.querySelector(`#${e}`);
  return t || (t = document.createElement("div"), t.id = e, a() && window.PortalContainer.setWidgetContainerContent(null, t)), t;
}
function k(e) {
  let t = e;
  const n = g(), o = O(n);
  let r = /* @__PURE__ */ new Map();
  return o && Object.keys(o).forEach((i) => {
    r.set(i, o[i]);
  }), C(t, r);
}
async function q() {
  if (a()) {
    const e = window.sessionStorage.getItem("gar::auth-token"), t = (/* @__PURE__ */ new Date()).getTime();
    if (e) {
      const { token: i, expiration: s } = JSON.parse(e);
      if (t < s)
        return Promise.resolve(i);
    }
    const n = await fetch("/_portal/Token?includeJwtToken=true");
    if (!n.ok)
      throw new Error("Unable to fetch the reference token");
    const { jwtToken: o } = await n.json(), r = t + 5 * 60 * 1e3;
    return window.sessionStorage.setItem("gar::auth-token", JSON.stringify({ token: o, expiration: r })), o;
  }
  return Promise.resolve("");
}
function G() {
  const e = window.sessionStorage.getItem("gar::base-url");
  if (e)
    return JSON.parse(e);
}
function I() {
  let e = document.querySelector("#divWidget");
  if (e || (e = document.querySelector('[data-gss-name="divWidget"]')), !e)
    throw new Error("Unable to find the component app container");
  return e;
}
function E(e) {
  let t;
  if (a()) {
    const n = U(e);
    if (!n)
      throw new Error("Unable to find the component settings.");
    if (t = document.querySelector(`[data-gss-name="${n.codeName}"]`), !t)
      throw new Error("Unable to find the section component container.");
  }
  return t;
}
function S(e, t = !0) {
  return e && typeof e == "string" ? (e = e.trim().toLowerCase(), !t || e.startsWith("gar_") ? e : `gar_${e}`) : (console.info("Unable to generate component code name"), "");
}
function U(e) {
  if (a()) {
    const t = window.GSS.pc.Components.getByCodeName(e);
    if (!t)
      throw new Error("Unable to find the component settings.");
    return t;
  }
}
function L(e) {
  if (a()) {
    const t = window.GSS.pc.Components.getById(e);
    if (!t)
      throw new Error("Unable to find the component settings.");
    return t;
  }
}
function x() {
  return a() ? window.gssportalui.dashboardContext || {} : {};
}
function g() {
  return a() ? window.PortalContainer.getDashboardWidgetId() : "";
}
function v(e, t) {
  return a() ? window.PortalContainer.getFullAppUrl(e, t) : "#";
}
function $(e, t, n) {
  return a() && e && e[t] ? v(e[t], n) : "";
}
function A() {
  var e;
  return a() && ((e = document == null ? void 0 : document.querySelector("[data-gss-clientId]")) == null ? void 0 : e.getAttribute("data-gss-clientId")) || "";
}
function j() {
  return a() ? window.PortalContainer.getSiteLanguage() : "en-US";
}
function B(e = "en-US") {
  const t = document.querySelector(
    'li[gss-data-language-selection-dropdown="' + e + '"] > a'
  );
  return t ? t.text : "English (USA)";
}
function h(e) {
  if (a()) {
    const t = A(), o = window.GSS.pc.Components.getById(e).codeName, r = window.GSS.common.addAntiForgeryToken({}).__RequestVerificationToken;
    return {
      gssClientId: t,
      gssComponentId: e,
      componentDefinitionCodeName: o,
      __RequestVerificationToken: r
    };
  }
}
function M(e) {
  if (a()) {
    const t = h(e);
    return P(t);
  }
  return "";
}
function O(e) {
  if (a()) {
    let t = e || g();
    return window.PortalContainer.setRequiredData(t || null, {});
  }
  return {};
}
function F(e) {
  return a() ? P(window.PortalContainer.setRequiredData(e, {})) : "";
}
function V(e) {
  let t = window.location, n = {}, o = t.search.substring(1), r = t.hash.split("?"), i = r.length > 0 ? r[0] : "";
  if (r && r.length > 1) {
    let s = r[1];
    n = w(s, n);
  }
  if (n = w(o, n), e && e.length) {
    let s = {};
    Object.keys(n).forEach((d) => {
      e.indexOf(d) > -1 && (s[d] = n[d]);
    }), n = s;
  }
  return {
    hashPathName: i,
    queryParams: n
  };
}
function Q(e) {
  return document.querySelector(`div[data-dashboard-widget-id="${e}"]`);
}
async function J(e) {
  return a() ? (e = e || g(), new Promise((t, n) => {
    window.PortalContainer.getWidgetSettings(e, (o) => {
      o ? t(o) : n("There was an error retreiving widget settings.");
    });
  })) : Promise.resolve({});
}
function H() {
  a() && window.PortalContainer.progressHide();
}
function z(e) {
  a() && window.PortalContainer.setWidgetStatus(
    e,
    window.PortalContainer.widgetStatus.available
  );
}
function K(e) {
  a() && window.PortalContainer.setWidgetStatus(
    e,
    window.PortalContainer.widgetStatus.error,
    null
  );
}
function X() {
  a() && window.PortalContainer.progressShow();
}
function Y(e) {
  a() && window.PortalContainer.setWidgetStatus(e, window.PortalContainer.widgetStatus.busy);
}
function P(e) {
  return !e || Object.keys(e).length === 0 ? "" : Object.keys(e).reduce((t, n, o) => {
    let r = e[n];
    const i = encodeURIComponent(Array.isArray(r) ? r.join(",") : r);
    return o > 0 ? t = `${t}&${n}=${i}` : t = `${n}=${i}`, t;
  }, "");
}
function w(e = "", t = {}) {
  return e && e.length && e.split("&").forEach((n) => {
    let o = n.split("=");
    t[o[0]] = decodeURIComponent(o[1]);
  }), t;
}
export {
  C as appendQueryParamsToURI,
  R as appendQueryStringToURL,
  D as createComponentContainer,
  N as createComponentURI,
  W as createFullAppContainer,
  k as createWidgetUrl,
  q as fetchJWTToken,
  S as generateComponentCodeName,
  G as getBaseUrlData,
  I as getComponentAppContainer,
  E as getComponentSectionContainer,
  U as getComponentSettingsByCodeName,
  L as getComponentSettingsById,
  x as getDashboardContext,
  g as getDashboardWidgetId,
  v as getFullAppUrlFromWidgetId,
  $ as getFullAppUrlFromWidgetSettings,
  A as getGSSClientId,
  j as getLanguageCode,
  B as getLanguageText,
  h as getRequiredComponentParams,
  M as getRequiredComponentParamsAsQuery,
  O as getRequiredData,
  F as getRequiredDataAsQuery,
  V as getUrlPathAndParams,
  Q as getWidgetContainer,
  J as getWidgetSettings,
  H as hideLoadingModal,
  z as hideLoadingStatus,
  T as initializeDevEnvironment,
  a as isHosted,
  K as showError,
  X as showLoadingModal,
  Y as showLoadingStatus,
  P as transformObjectToQueryString,
  w as transformQueryStringToObject
};
//# sourceMappingURL=pc-utils.js.map
